<template>
  <div
    class="main-desktop-tabs-primary-item-label"
    @contextmenu="handleContextMenu"
  >
    <UIInputString
      v-if="isEditMode"
      v-model="labelValue"
      @save="handleSave"
    />
    <template v-else>
      <ViewTabDropdown
        ref="dropdownRef"
        :item
        :disabled="isDisabled"
        @edit="isEditMode = true"
      >
        {{ item.label }}
      </ViewTabDropdown>
      <span
        v-if="isDirty"
        class="main-desktop-tabs-primary-item-label__dirty"
      >
        *
      </span>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed, inject, ref, useTemplateRef } from 'vue'

import { NavigationItem, ReadonlyMode } from '@types'

import { READONLY_MODE } from '@/const'

import ViewTabDropdown from './components/ViewTabDropdown.vue'
import { UIInputString } from '@ui/fields'

type Props = {
  item: NavigationItem
  disabled?: boolean
}

const props = defineProps<Props>()

const dropdownRef = useTemplateRef('dropdownRef')

const isReadonly = inject<ReadonlyMode>(READONLY_MODE)

const isEditMode = ref(false)
const labelValue = ref(props.item.label || '')

const isDirty = computed(() => props.item?.isDirty)

const isDisabled = computed(() => props.disabled || isReadonly?.value)

const handleSave = (_: string, callback: () => void) => {
  props.item.update?.(labelValue.value, () => {
    isEditMode.value = false
    callback()
  })
}

const handleContextMenu = (event: MouseEvent) => {
  event.preventDefault()
  if (props.disabled) return
  dropdownRef.value?.show()
}
</script>

<style>
.main-desktop-tabs-primary-item-label {
  @apply relative;

  &__dirty {
    @apply absolute bottom-0.5 left-full;
    @apply text-yellow-500;
  }
}
</style>
